export const optionGroupKeys = {
    root: ['optionGroups'] as const,
    filterData: (projectId: number) => ['optionGroups', projectId, 'filterData'] as const,
};

